import { hot } from "react-hot-loader";

import DrawerForm from "../DrawerForm";

export default hot(module)(DrawerForm);
